import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Objects, Collections} from "components";

import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import {Alert, Button} from "reactstrap";
import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import UniversalModalOverride from "components/UniversalModalOverride";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Access from "constants/Access";
import {TextField} from "@mui/material";

const {getFullID} = Framework.Utilities;


class Location extends Framework.Components.View {
	static defaultProps = {
		bound_book: '',
	}

	constructor(props) {
		super(props, 'bound_books');

		this.tcModel = new API.BuildClass(
			Types.Transactions_Collections._name,
			props.id ? API.RequestType.READ : API.RequestType.CREATE
		);

		this.state = {
			...this.state,
			bound_book: props.bound_book,
			bound_book_error: '',
			locationName: '',
			boundBookName: '',
			primaryBoundBookName: 'Primary',
			missingSubscription: false,
			...this.findCurrentLocationAndBoundBook(),
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.bound_book !== this.props.bound_book || prevProps.location !== this.props.location) {
			this.setState({
				bound_book: this.props.bound_book || '',
				...this.findCurrentLocationAndBoundBook()
			});
		}
	}

	findCurrentLocationAndBoundBook = () => {
		/** @type {Locations_Object} locationMatch */
		let locationMatch = this.props.rootState.locations.find(
			(item) => getFullID(item) === this.props.location
		);
		let boundBook;
		let nextState = {
			locationName: '',
			boundBookName: '',
			missingSubscription: false,
		};

		if (locationMatch) {
			nextState.locationName = locationMatch.name_display || locationMatch.name;

			if (locationMatch.archived) {
				this.props.history.push('/locations');
				return;
			}

			if (!locationMatch.subscription && !locationMatch.archived) {
				nextState.missingSubscription = true;
			}

			boundBook = locationMatch.location_bound_bookss.find(
				(item) => getFullID(item) === this.props.bound_book
			);

			nextState.primaryBoundBookName = locationMatch.bound_book || 'Primary';
			if (!boundBook) {
				nextState.boundBookName = locationMatch.bound_book || 'Primary';
			} else {
				nextState.boundBookName = boundBook.name;
			}
		}

		return nextState;
	}

	// handleFirearmTraceLookup = async () => {
	// 	let bbModel = new API.BuildClass(Types.Locations_Bound_Books_Queues._name, API.RequestType.CREATE)
	// 	bbModel.object.serial_trace = this.state.serial_trace;
	// 	bbModel.request = 'PUT_FIREARM_TRACE';
	// 	let result = await bbModel.submit(null, 'PUT_FIREARM_TRACE');
	// 	let pdf_file = result.file.split('/')[9];
	// 	let link = `https://dev.api.fflboss.com/v415/locations/bound_books/queues/trace_pdf?image=${pdf_file}`;
	// 	window.open(link);
	//
	// }

	handleAfterSave = (data) => {
		if (data.pkey === 0) {
			this.setState({
				primaryBoundBookName: data.name || 'Primary'
			})
		}
		this.props.rootState.reloadShell();
		this.refreshPage();
	}
	handleAfterDelete = () => {
		this.props.history.push('/locations/' + this.props.location)
		this.props.rootState.reloadShell();
		this.refreshPage();
	}

	handleSelectPropertyUpdate = (property, value, linked, object) => {
		if (!value) {
			if (this.state.bound_book !== '') {
				this.setState({
					bound_book: ''
				});
				this.props.history.push(`/locations/${this.props.location}`);
			}
		} else {
			if (object) {
				if (this.state.bound_book !== getFullID(object)) {
					this.setState({
						bound_book: getFullID(object)
					});
					this.props.history.push(`/locations/${this.props.location}/${getFullID(object)}`);
				}
			}
		}

	};

	redirectTo = (objectType) => () => {
		this.props.history.push('/' + objectType + '/' + this.props.location + (this.props.bound_book ? '/' + this.props.bound_book : ''));
	}

	render() {
		let {location, bound_book, rootState} = this.props;
		let {kioskMode, locations, states, reloadShell, scannedCode, userAccess} = rootState;
		let {locationName, boundBookName, primaryBoundBookName} = this.state;
		let breadcrumbs = [
			{
				name: 'Dashboard',
				url:  this.props.kioskMode ? `/locations/${location}` : '/',
				icon: 'dashboard',
			},
			{
				name: 'Locations',
				url:  this.props.kioskMode ? `/locations/${location}` : '/locations',
				icon: 'building',
			},
			{
				name: locationName || location,
				url: `/locations/${location}`,
				icon: 'building-o',
			},
			{
				name: boundBookName || 'Primary',
				url: `/locations/${location}${bound_book ? `/${bound_book}` : ''}`,
				icon: 'book',
			}
		];
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}>
					{!kioskMode && userAccess <= Access.Owner &&
					<Button
						data-id="add-customer"
						onClick={this.toggle('modalBoundBookAdd')}
						size="sm"
						color="primary"
					>
						<i className="fa fa-plus"/>&nbsp;&nbsp;Add Bound Book
					</Button>}
					<UniversalModalOverride
						parent={location}
						locations={locations}
						states={states}
						name="Bound Book"
						object={Objects.BoundBookAdd}
						history={this.props.history}
						toggle={this.state['modalBoundBookAdd']}
						reportClose={this.reportClose('modalBoundBookAdd')}
						afterSave={this.handleAfterSave}
					/>
				</Framework.Components.PageBar>

				{this.props.rootState.userAccess !==0 && this.state.tab === 'details' &&
					<div className="warning-message">
						The Account Owner needs to login to access this area.
					</div>
				}

				<div className="row">
					<div className="col-8">
						<div className="row">
							<div className="col-1">
								<span className="input-label">Bound Book</span>
							</div>
							<div className="col-3">
								<Framework.Elements.Select
									key={this.state.key}
									parent={location}
									shouldLoad={true}
									update={this.handleSelectPropertyUpdate}
									value={this.state.bound_book.split('-')[1] || ''}
									binary_id={this.state.bound_book.split('-')[0] || ''}
									error={this.state.bound_book_error}
									// objects={location.location_bound_bookss}
									property={this.tcModel.properties.bound_book}
									hideLabel={true}
									nullable={true}
									default={{
										value: "",
										label: primaryBoundBookName
									}}
								/>
							</div>

							{!kioskMode && userAccess <= Access.Owner && <div className="col-1">
								<span>
									<Button
										color="green-meadow"
										size="sm"
										block={false}
										onClick={this.toggle('modalBoundBookEdit')}
										style={{marginTop: '2px', marginLeft: '-10px'}}
									>
										<i className={"fa fa-pencil"}/>
									</Button>
								</span>
								<UniversalModalOverride
									id={bound_book ? bound_book : '0'}
									parent={location}
									locations={locations}
									states={states}
									name="Bound Book"
									object={Objects.BoundBookEdit}
									history={this.props.history}
									toggle={this.state['modalBoundBookEdit']}
									reportClose={this.reportClose('modalBoundBookEdit')}
									afterSave={this.handleAfterSave}
									afterDelete={this.handleAfterDelete}
									hideGoTo={true}
									title="Update Bound Book"
									submitLabel="Update Bound Book"
									hasDelete={!!bound_book}
								/>
							</div>}
							{/*<div className="col-6">*/}
							{/*	<div className="form-group">*/}
							{/*		<TextField*/}
							{/*			label={"Serial Number"}*/}
							{/*			value={this.state.serial_trace}*/}
							{/*			onChange={(event) => this.setState({serial_trace: event.currentTarget.value}) }*/}
							{/*			size={'small'}*/}
							{/*			style={{paddingRight: '20px'}}*/}
							{/*		/>*/}
							{/*		<Button color="warning" onClick={this.handleFirearmTraceLookup}>Trace Firearm</Button>*/}
							{/*	</div>*/}
							{/*</div>*/}
						</div>
					</div>
					<div className="col">
						<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
							<Tab label="Bound Books" value={'bound_books'}/>
							<Tab label="Downloads" value={'downloads'}/>
							{!kioskMode && userAccess <= Access.Owner && <Tab label="Details" value={'details'}/>}
							{kioskMode === '2' && <Tab label="Flagged" value={'flagged'}/>}
							{/*{!kioskMode && userAccess <= Access.Owner && <Tab label="Add-ons" value={'add-ons'}/>}*/}
						</Tabs>
					</div>
				</div>

				<div style={{display: this.state.tab === 'bound_books' ? 'block' : 'none'}}>
					{this.state.missingSubscription &&
					<Card style={{overflow: 'visible'}}>
						<CardContent style={{padding: '14px'}}>
							<Alert color="danger" style={{marginBottom: '0'}}>
								<p style={{fontSize: '18px', marginBottom: '0px'}}>
									The location's subscription has expired or been canceled. Please renew your subscription to continue accessing
									your data.
								</p>
							</Alert>
						</CardContent>
					</Card>}
					{!this.state.missingSubscription && <Collections.BoundBooks
						id={this.props.match.params.bound_book}
						parent={location}
						history={this.props.history}
						locations={locations}
						states={states}
						reloadShell={reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						kioskMode={kioskMode}
						scannedCode={scannedCode}
						handleTabChange={this.handleTabChange}
						rootState={rootState}
					/>}
				</div>

				{this.state.tab === 'downloads' &&
				<Collections.LocationsBoundBookDownloads
					parent={location}
					history={this.props.history}
					locations={locations}
					states={states}
					reloadShell={reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>}

				{this.state.tab === 'details' && userAccess <= Access.Owner &&
				<Objects.LocationDetail
					id={location}
					history={this.props.history}
					locations={locations}
					states={states}
					reloadShell={reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					baseUrl={this.props.baseUrl}
					deleteText={"Delete & Archive"}
				/>}

				{this.state.tab === 'flagged' &&
					<Collections.LocationBoundBookFlags
						id={location}
						history={this.props.history}
						locations={locations}
						states={states}
						reloadShell={reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						baseUrl={this.props.baseUrl}
						deleteText={"Archive"}
					/>}

				{/*{this.state.tab === 'add-ons' && userAccess <= Access.Owner &&*/}
				{/*<Objects.LocationAddOns*/}
				{/*	parent={location}*/}
				{/*	history={this.props.history}*/}
				{/*	locations={locations}*/}
				{/*	states={states}*/}
				{/*	reloadShell={reloadShell}*/}
				{/*	reloadPage={this.refreshPage}*/}
				{/*	reloadSelf={this.state.refresh}*/}
				{/*	baseUrl={this.props.baseUrl}*/}
				{/*/>}*/}
			</div>
		);
	}
}

export default Framework.Components.withRootState(Location);